import { Infobulle } from './Infobulle';

/**
 * « Proposée à l'inscription en ligne », en icône : un globe, bleu comme
 * l'ancien tag qu'il remplace (2026-10-02). Le sens survit dans
 * l'infobulle commune et dans `aria-label`.
 */
export function IconeEnLigne() {
  const libelle = 'Proposée à l’inscription en ligne';
  return (
    <Infobulle texte={libelle} className="inline-flex">
      <svg viewBox="0 0 16 16" className="h-4 w-4 shrink-0 text-blue-700" role="img" aria-label={libelle}>
        <circle cx="8" cy="8" r="6.3" fill="none" stroke="currentColor" strokeWidth="1.4" />
        <ellipse cx="8" cy="8" rx="2.6" ry="6.3" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M1.9 8h12.2M2.9 4.9h10.2M2.9 11.1h10.2" stroke="currentColor" strokeWidth="1.1" />
      </svg>
    </Infobulle>
  );
}
